export class WebAppInfo {
  public readonly appVersion = "1.5.20 (4)";

}

